import { Injectable } from '@angular/core';

import { AppInfoConfig, ClientConfigProductName, NativeAppService, ProductService } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class InvokerProductService {
    invokerProduct: string;
    constructor(
        private appInfoConfig: AppInfoConfig,
        private nativeAppService: NativeAppService,
        private productService: ProductService,
    ) {}

    getInvokerProduct(): string {
        // Note: Single domain app condition is temporary, until we move all products to single domain
        if (this.productService.isSingleDomainApp && this.productService.current.name === ClientConfigProductName.HOST) {
            this.productService.setActive(ClientConfigProductName.CASINO);
        }

        let appProduct: string = this.productService.isSingleDomainApp
            ? this.productService.current.name
            : this.appInfoConfig?.product?.toLowerCase();
        if (this.nativeAppService.isNative) {
            appProduct = this.nativeAppService?.product?.toLowerCase();
        }
        return appProduct;
    }
}
